import { Typography } from 'antd';
import styled from 'styled-components';
import { FONTS } from '../../constants';
import { sharedTypographyStyles } from '../../styled';

export const StyledText = styled(Typography.Text)`
    ${sharedTypographyStyles};
    font: ${({ $type = 'body2' }) => FONTS[$type]};
`;
